import http from "./Http";

const listarRegiones = async () => {
  const response = await http.get("/ubicacion/regiones");
  return response.data;
};

const listarProvincias = async (region_id) => {
  const response = await http.get("/ubicacion/provincias", {
    params: { region_id },
  });
  return response.data;
};

const listarDistritos = async (provincia_id) => {
  const response = await http.get("/ubicacion/distritos", {
    params: { provincia_id },
  });
  return response.data;
};

const UbicacionService = {
  listarRegiones,
  listarProvincias,
  listarDistritos,
};

export default UbicacionService;